<template>
  <div class="jy-overview">
    <div class="range">
      <span class="label">年份范围</span>
      <el-slider v-model="dateValue" :min="0" :max="max" :show-tooltip="false" :marks="marks" range
        @change="yearMonthChange"></el-slider>
    </div>

    <Overview1></Overview1>
    <Overview2></Overview2>
    <Overview3></Overview3>
    <Overview4></Overview4>
  </div>
</template>

<script>
import Overview1 from './Overview1.vue'
import Overview2 from './Overview2.vue'
import Overview3 from './Overview3.vue'
import Overview4 from './Overview4.vue'
export default {
  name: 'BusinessOverview',
  components: {
    Overview1,
    Overview2,
    Overview3,
    Overview4
  },
  data() {
    return {
      dateValue: [],
      dateList: [],
      max: 2
    }
  },
  computed: {
    marks() {
      return {
        [this.dateValue[0]]: this.dateList[this.dateValue[0]],
        [this.dateValue[1]]: this.dateList[this.dateValue[1]]
      }
    }
  },
  watch: {
  },
  created() {
  },
  async mounted() {
    const startDate = await this.loadYearMonth()
    if (!startDate) {
      this.$message.warning('暂无数据')
      return
    }
    const endDate = this.$dayjs().subtract(1, 'month')
    this.max = endDate.diff(startDate, 'month')
    this.dateValue = [this.max - 11 > 0 ? this.max - 11 : 0, this.max]
    this.dateList = Array.from({ length: this.max + 1 }).map((_, index) => {
      return this.$dayjs(startDate).add(index, 'month').format('YYYY-MM')
    })
    this.$nextTick(() => {
      this.$event.$emit('yearMonthChange', {
        startTime: this.dateList[this.dateValue[0]],
        endTime: this.dateList[this.dateValue[1]]
      })
    })
  },
  methods: {
    loadYearMonth() {
      return this.$axios.get(this.$apis.operate.selectMinContractStartYm)
    },
    yearMonthChange(value) {
      this.$event.$emit('yearMonthChange', {
        startTime: this.dateList[value[0]],
        endTime: this.dateList[value[1]]
      })
    }
  }
}
</script>

<style scoped lang="scss">
.jy-overview {
  margin: -20px;
  padding: 20px;
  background: #F5F6FA;
}

.range {
  display: flex;
  align-items: center;
  padding: 0 40px;

  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    margin-right: 34px;
  }

  .el-slider {
    flex: 1;

    ::v-deep {
      .el-slider__marks-text {
        width: 80px;
        text-align: center;
      }
    }
  }
}
</style>
